'use client'

import { useCallback } from 'react'
import { usePathname } from 'next/navigation'

export const useThanksForAppRouter = () => {
  const pathname = usePathname()

  const pushThanks = useCallback(
    (to: string) => {
      const currentPath = pathname || '/'
      const path = currentPath.split('/').filter(Boolean)
      const fromPath = path.length > 0 ? path.join('-') : 'home'
      const newUrl = `/${to}/?from=${fromPath}`

      window.location.href = newUrl
    },
    [pathname]
  )

  return { pushThanks }
}
